export enum FeatureFlag {
  PROPOSTA_SALES_REP = 'proposta_sales_rep',
  PROPOSTA_SALES_OPS = 'proposta_sales_ops',
  PROPOSTA_VARIANTES = 'proposta_variantes',
  LEADS = 'leads',
  EMPRESAS = 'empresas',
  KANBAN = 'kanban',
  LEADS_QUALIFICACAO = 'leads_qualificacao',
  LEAD_REGISTRAR_RESULTADO = 'lead_registrar_resultado',
  TRATATIVAS_CONTRATO = 'tratativas_contrato',
  TRATATIVAS_ENVIO_ANALISE = 'tratativas_envio_analise',
  CHECKLIST_ONBOARDING = 'checklist_onboarding',
  CRIACAO_USER_AGIRH = 'criacao_user_agirh',
  INDICADORES_DASHBOARD = 'indicadores_dashboard',
  MULTI_DASHBOARDS = 'multi_dashboards',
  NEGOCIACAO_MULTIPRODUTO = 'negociacao_multiproduto',
  HABILITAR_SEGURO = 'habilitar_seguro',
}
